export const LOGIN_GUIDE_STATE = {
  BAR: "bar",
  BUOY: 'buoy'
}
